import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { SPOT_FILL_RATE_LINE_CHART_DEFINITION } from './spot-fill-rate-line-chart.definition';
import { SPOT_FILL_RATE_LINE_CHART_MOCK_DATA } from './spot-fill-rate-line-chart.mock';

export const SpotFillRateLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

SpotFillRateLineChart.definition = SPOT_FILL_RATE_LINE_CHART_DEFINITION;
SpotFillRateLineChart.mockData = SPOT_FILL_RATE_LINE_CHART_MOCK_DATA;
